import { Button } from "@chakra-ui/button";
import { Heading, Stack, VStack } from "@chakra-ui/layout";
import { chakra } from "@chakra-ui/system";
import { yupResolver } from "@hookform/resolvers/yup";
import { useToast } from "hooks/useToast";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useSearchParams } from "react-router-dom";
import { useMutation } from "react-query";
import { useNavigate } from "react-router";
import { useCheckResetTokenValidity } from "../api/checkResetTokenValidity";
import { apiErrorHandler } from "utils/errors";
import * as yup from "yup";
import { updatePassword } from "..";
import { Layout } from "../components/Layout";
import { LoginField } from "../components/LoginField";

type PasswordResetValues = {
  password: string;
  confirmPassword: string;
};

const schema = yup.object({
  password: yup.string().required(),
  confirmPassword: yup
    .string()
    .required()
    .oneOf(
      [yup.ref("password"), null],
      "Les mots de passe ne correspondent pas."
    ),
});

export const PasswordReset: React.FC = () => {
  const navigate = useNavigate();
  const toast = useToast();
  const [searchParams] = useSearchParams();
  const [done, setDone] = useState(false);
  const token = searchParams.get("token");

  if (!token) {
    navigate("/auth/lostpassword");
  }

  const { isLoading: isLoadingValidity } = useCheckResetTokenValidity({
    token: token || "",
    config: {
      onError: (e: any) => {
        navigate("/auth/lostpassword");
      },
    },
  });

  const { register, setError, formState, handleSubmit } =
    useForm<PasswordResetValues>({
      resolver: schema && yupResolver(schema),
    });
  const { mutate, isLoading } = useMutation({
    mutationFn: updatePassword,
    onSuccess: (data) => {
      toast({
        position: "top",
        description:
          "Mot de passe modifié avec succès. Vous pouvez vous authentifier",
        status: "success",
      });
      setDone(true);
      // navigate("/auth/login");
    },
    onError: (e: any) => apiErrorHandler(e, setError),
  });

  return !done ? (
    <Layout title="Changement de mot de passe">
      <VStack
        spacing={4}
        justify="center"
        w={["full", null, null, "container.lg"]}
        p={["20px"]}
      >
        <Heading
          fontWeight="normal"
          fontSize="20px"
          color="brand.primary"
          mt={8}
          mb={16}
        >
          Veuillez choisir votre nouveau mot de passe
        </Heading>

        <chakra.form
          id="register"
          onSubmit={handleSubmit(async (values: any) => {
            mutate({ newPassword: values.password, token: token || "" });
          })}
          width={["full", "350px"]}
          maxWidth={"350px"}
        >
          <>
            <Stack spacing="24px" direction={"column"} mb={2} px={["20px"]}>
              <LoginField
                error={formState.errors["password"]}
                registration={register("password")}
                placeholder={"Mot de passe"}
                type="password"
              />

              <LoginField
                error={formState.errors["confirmPassword"]}
                registration={register("confirmPassword")}
                placeholder={"Confirmation mot de passe"}
                type="password"
              />
            </Stack>
            <Button
              bg="brand.primary"
              type="submit"
              h="48px"
              isLoading={isLoading || isLoadingValidity}
              mt={10}
            >
              Envoyer
            </Button>
          </>
        </chakra.form>
      </VStack>
    </Layout>
  ) : null;
};
